import { COMMON_ERROR } from 'utils/ErrorMessages'

import { SAVE_AND_TEST_CAMPAIGN_ASYNC } from 'containers/AwarenessCenter/WizardCampaign/steps/constants'
import { SEND_TRY_IT_OUT_ASYNC } from 'containers/AwarenessCenter/WizardCampaign/steps/ReviewAndLaunchStep/constants'

import {
  FETCH_SHARING_EMAILS_ASYNC,
  SHARE_EMAILS_CHANGE,
  SHARE_MESSAGE_CHANGE,
  FILE_TYPE_CHANGE,
  SHARE_RESET,
  SHARE_RESET_ERROR,
  SHARE_SUBMIT_ASYNC,
  HTML_OPTION_CONST,
} from './constants'

const initialState = {
  message: '',
  fileType: HTML_OPTION_CONST,
  selectedProfilesProperties: [],
  profilesProperties: {
    items: [],
    meta: {
      count: undefined,
    },
  },

  loader: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SHARE_RESET:
      return {
        ...state,
        selectedProfilesProperties: [],
        message: '',
        fileType: HTML_OPTION_CONST,
        error: null,
      }
    case SHARE_RESET_ERROR:
      return {
        ...state,
        error: null,
      }
    case FETCH_SHARING_EMAILS_ASYNC.SUCCESS:
      return {
        ...state,
        profilesProperties: action.payload.data,
      }
    case SHARE_SUBMIT_ASYNC.INITIATE:
      return {
        ...state,
        loader: true,
        error: null,
      }
    case SHARE_SUBMIT_ASYNC.SUCCESS:
      return {
        ...state,
        loader: false,
      }
    case SHARE_SUBMIT_ASYNC.ERROR:
      return {
        ...state,
        loader: false,
        error: COMMON_ERROR,
      }
    case SHARE_EMAILS_CHANGE:
      return {
        ...state,
        selectedProfilesProperties: action.payload.data,
      }
    case SHARE_MESSAGE_CHANGE:
      return {
        ...state,
        message: action.payload.value,
      }
    case FILE_TYPE_CHANGE:
      return {
        ...state,
        fileType: action.payload.value,
      }

    case SAVE_AND_TEST_CAMPAIGN_ASYNC.INITIATE:
      return {
        ...state,
        loader: true,
        error: null,
      }

    case SEND_TRY_IT_OUT_ASYNC.SUCCESS:
      return {
        ...state,
        loader: false,
      }
    case SEND_TRY_IT_OUT_ASYNC.ERROR:
      return {
        ...state,
        loader: false,
        error: action.error.detail,
      }

    default:
      return state
  }
}
